/**
 * WordPress dependencies
 */
import { store, getContext, getElement } from '@wordpress/interactivity';

const { state } = store('tantrachair', {
	state: {
		get selectedColor() {
			const { selectedColor } = getContext();
			return selectedColor;
		},
		get isSelectedColor() {
			const { color } = getContext();

			return state.selectedColor === Number(color.term_id);
		},
		get selectedNailheads() {
			const { selectedNailheads } = getContext();
			return selectedNailheads;
		},
		get isSelectedNailheads() {
			const { nailhead } = getContext();

			return state.selectedNailheads === Number(nailhead.term_id);
		},
		get selectedVariation() {
			const { variations } = getContext();

			return variations.filter((item) => {
				return item.category_id == state.selectedNailheads && item.color_id === state.selectedColor;
			})[0];
		},
		get selectedVariationTitle() {
			return state.selectedVariation.post_title + ' with ' + state.selectedVariation.category.name;
		},
		get selectedVariationAddToCartLink() {
			return '?add-to-cart=' + state.selectedVariation.ID;
		},
	},
	actions: {
		selectColor() {
			const context = getContext();

			if (context.selectedColor === Number(context.color.term_id)) return;

			context.isLoading = true;

			setTimeout(() => {
				context.selectedColor = Number(context.color.term_id);
			}, 200);
		},
		selectNailheads() {
			const context = getContext();

			if (context.selectedNailheads === Number(context.nailhead.term_id)) return;

			context.isLoading = true;

			setTimeout(() => {
				context.selectedNailheads = Number(context.nailhead.term_id);
			}, 200);
		},
		selectReset() {
			const context = getContext();

			if (
				context.selectedColor === Number(context.variations[0].color_id) &&
				context.selectedNailheads === Number(context.variations[0].category_id)
			) return;

			context.isLoading = true;

			setTimeout(() => {
				context.selectedColor = context.variations[0].color_id;
				context.selectedNailheads = context.variations[0].category_id;
			}, 200);
		},
	},
	callbacks: {
		image: {
			onLoad: () => {
				const context = getContext();

				context.isLoading = false;
			}
		},
	},
});
